import { apiCall } from "./auth";
import { API_URL } from "./config";

export const getStagingStations = () => apiCall(`${API_URL}stagingStations/getStagingStations`, "GET");
export const getsingleStagingStations = (data) => apiCall(`${API_URL}stagingStations/getsingleStagingStations`, "POST",data);
export const upateStagingStationStatus = (data) => apiCall(`${API_URL}stagingStations/upateStagingStationStatus`, "POST",data);
export const getAllStagingStations = (data) => apiCall(`${API_URL}stagingStations/getAllStagingStations`, "POST",data);
export const getNonEmptyStations = (data) => apiCall(`${API_URL}stagingStations/getNonEmptyStations`, "POST",data);
